import { Application } from "stimulus";
import highlightsController from "../../../controllers_v2/highlights_controller";

const application = Application.start();

application.register("highlights", highlightsController);
